// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"113":"logout","567":"gallery2","594":"about","759":"create-annotation","859":"annotation-tool","966":"login"}[chunkId] || chunkId) + "." + {"113":"3dd947f7","114":"4f6c17d6","543":"3105f59a","567":"9b8be34e","594":"94c84f6c","759":"6792cf69","859":"f6b14188","966":"dc8ef605"}[chunkId] + ".js";
};